/* src/app/layout/profile-dropdown/profile.component.scss */
.di-user-dropdown {
  background: #004c93;
  height: 36px;
  width: 36px;
  border-radius: 36px;
  border: 0;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-profile-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.mdc-button.header-cart {
  margin: 0 15px 0 0;
  color: #000000;
  padding: 15px;
  height: 40px;
  width: 40px;
  min-width: auto;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.mdc-button.header-cart .material-symbols-outlined {
  font-size: 24px;
}
.mdc-button.header-cart .counter {
  height: 20px;
  width: 20px;
  background: #004c93;
  border-radius: 20px;
  position: absolute;
  right: 0px;
  top: -5px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  border: 2px solid #f8f8f8;
}
.user-dropdown-wrapper .mat-mdc-menu-content {
  padding: 0 !important;
  background: #ffffff;
}
.user-dropdown-wrapper .mat-mdc-menu-content .user-details {
  display: flex;
  align-items: center;
  padding: 10px !important;
  font-family: "Source Sans Pro", sans-serif;
}
.user-dropdown-wrapper .mat-mdc-menu-content .user-details .user-image {
  height: 48px;
  width: 48px;
  border-radius: 48px;
  min-width: 48px;
  margin: 0 10px 0 0;
  overflow: hidden;
}
.user-dropdown-wrapper .mat-mdc-menu-content .user-details .user-name {
  word-break: break-word;
}
.user-dropdown-wrapper .mat-mdc-menu-content .user-details .user-name h3 {
  margin: 0;
  font-weight: 600;
  line-height: 1;
  font-size: 1.3rem !important;
}
.user-dropdown-wrapper .mat-mdc-menu-content .user-details .user-name div {
  line-height: 1;
  margin: 5px 0 0 0;
}
.user-dropdown-wrapper .mat-mdc-menu-content .mat-mdc-menu-item {
  height: 36px;
  min-height: 36px;
  font-family: "Source Sans Pro", sans-serif;
  line-height: 36px;
}
.user-dropdown-wrapper .mat-mdc-menu-content .mat-mdc-menu-item .mat-mdc-menu-item-text {
  display: flex;
  align-items: center;
}
.user-dropdown-wrapper .mat-mdc-menu-content .mat-mdc-menu-item .material-symbols-outlined {
  margin-right: 5px;
  font-size: 18px;
  height: 18px;
  width: 18px;
}
/*# sourceMappingURL=profile.component-J62WQUFE.css.map */
